import React from 'react'
import { withFormik, Form, ErrorMessage } from 'formik'
import { TextField, Button, Grid, makeStyles } from '@material-ui/core'
import { lighten } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { attemptLogin } from '../../redux/actions/authActions'
import { errorMsg } from '../../redux/actions/alertMessageActions'
import { string, object } from 'yup'

const useStyles = makeStyles(theme => ({
    textField: {
        '& label': {
            color: 'white',
        },
        '& label.Mui-focused': {
            color: '#d7bb77',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'white',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#d7bb77',
        },
        '& .MuiInputBase-input': {
            color: 'white',
        },
    },
    button: {
        borderRadius: '30px',
        color: 'white',
        background: '#d7bb77',
        '&:hover, &:focus': {
            background: lighten('#d7bb77', .5),
            border: 'none'
        },
        width: '11em'
    }
}))

const LoginFormRaw = ({
    values,
    isSubmitting,
    handleChange
}) => {
    const styles = useStyles()

    return (
        <Form>
            <Grid container spacing={5} direction='column' justify='center'>
                <Grid item xs={12}>
                    <TextField
                        label='ایمیل'
                        name='email'
                        onChange={handleChange}
                        value={values.email}
                        className={styles.textField}
                        fullWidth
                    />
                    <ErrorMessage name='email'>
                        {err => <article
                            className='text-danger mt-2 text-right'
                        >{err}</article>}
                    </ErrorMessage>
                </Grid>

                <Grid item xs={12} className='mb-5'>
                    <TextField
                        label='رمز عبور'
                        name='password'
                        type='password'
                        onChange={handleChange}
                        value={values.password}
                        className={styles.textField}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} className='pt-2 text-center'>
                    <Button
                        type='submit'
                        variant='contained'
                        className={styles.button}
                        disabled={isSubmitting}
                        id='login-form-submit-button'
                    >ورود</Button>
                </Grid>
            </Grid>
        </Form>
    )
}

const LoginForm = withFormik({
    mapPropsToValues: (props) => ({
        email: '',
        password: ''
    }),
    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        setSubmitting(true)

        try {
            props.dispatch(attemptLogin(values))
            resetForm()
        } catch (error) {
            console.log(error)
            props.dispatch(errorMsg('بروز خطا در ورود به سایت لطفا دوباره تلاش کنید'))
        }
    },
    validationSchema: object().shape({
        email: string().email('فرمت ایمیل صحیح نیست').required('ایمیل الزامی است'),
    })
})(LoginFormRaw)

export default connect()(LoginForm)